import HttpErrors from "http-errors";

import type { Sdk } from "./shopify-graphql/types";
import { getSdk } from "./shopify-graphql/types";
import {
  createShopifyStorefrontApiUrl,
  hasGraphQLErrors,
  parseJsonOrIgnore,
} from "./utils";

export interface ShopifySdkArgs {
  storefrontApiVersion: "2025-04";
  storeDomain: string;
  storefrontToken: string;
}

export class Shopify {
  sdk: Sdk;

  constructor(args: ShopifySdkArgs) {
    this.sdk = getSdk(async (query, variables) => {
      const response = await fetch(
        createShopifyStorefrontApiUrl(
          args.storeDomain,
          args.storefrontApiVersion,
        ),
        {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": args.storefrontToken,
          }),
          body: JSON.stringify({ query, variables }),
        },
      );

      if (response.status !== 200) {
        const body = await parseJsonOrIgnore(response);

        if (hasGraphQLErrors(body)) {
          throw new HttpErrors.UnprocessableEntity(
            body.errors.map((error) => error.message).join(", "),
          );
        }

        const error = HttpErrors(response.status);
        error.message = `Unexpected status ${response.status} from API`;
        error.data = body;
        throw error;
      }

      const results = await response.json();

      return results.data;
    });
  }
}
